<template>
    <v-dialog v-model="show" fullscreen transition="slide-y-transition" overlay-color="#111" overlay-opacity="0.95"
        :style="`${isAndroidNative ? 'margin-top: 100px; height: 100vh;' : ''} `">
        <v-card class="bg-dark pa-4 licensing-dialog">
            <v-btn variant="tonal" class="mt-6" @click="close"
                style="position: absolute; top: 12px; right: 12px; z-index: 10; transition: 0.3s ease;color: #fff;">

                {{ $t('closeButton') }}
            </v-btn>

            <div class="content-scroll">
                <h2 class="text-white mb-6 text-center font-weight-bold">{{ $t('finance.title') }}</h2>

                <!-- Card Section -->
                <v-row class="mb-6" justify="center" align="center" no-gutters>
                    <v-col cols="12" sm="6" md="4" class="pa-2" v-for="(card, i) in $tm('finance.cards')" :key="i">
                        <v-card class="finance-card">
                            <v-icon :color="card.color" size="32">{{ card.icon }}</v-icon>
                            <div class="text-white font-weight-bold mt-2">{{ $t(`finance.cards[${i}].title`) }}</div>
                            <ul class="text-white mt-2 bullet-list">
                                <li v-for="(point, j) in card.points" :key="j">{{ point }}</li>
                            </ul>
                        </v-card>
                    </v-col>
                </v-row>

                <!-- Financial Flow Visual -->
                <div class="flow-wrapper">
                    <div v-for="(step, index) in $tm('finance.flow')" :key="index" class="flow-step">
                        <v-icon :color="step.color" size="30">{{ step.icon }}</v-icon>
                        <span class="flow-label">{{ step.label }}</span>
                        <v-icon v-if="index < $tm('finance.flow').length - 1" size="24"
                            color="cyan">mdi-arrow-right</v-icon>
                    </div>
                </div>
            </div>
        </v-card>
    </v-dialog>
</template>


<script setup>
import { ref, defineExpose } from 'vue';
import { Capacitor } from '@capacitor/core';

const show = ref(false);
function open() { show.value = true; }
function close() { show.value = false; }
defineExpose({ open });
const isAndroidNative = Capacitor.getPlatform() === 'android' && Capacitor.isNativePlatform();

const cards = [
    {
        title: 'Flexible Pricing',
        icon: 'mdi-currency-eur',
        color: 'cyan',
        points: [
            'CAPEX, OPEX, or hybrid',
            'Per desk, m², or employee',
            'Tailored to project scale'
        ]
    },
    {
        title: 'Fast Onboarding',
        icon: 'mdi-rocket-launch-outline',
        color: 'light-blue',
        points: [
            'No complex setup',
            'Ready-to-use templates',
            'Proven success cases'
        ]
    },
    {
        title: 'Unlock Hidden Value',
        icon: 'mdi-treasure-chest',
        color: 'amber',
        points: [
            'Optimize space usage',
            'Leverage legacy infrastructure',
            'Increase operational ROI'
        ]
    }
];

const flow = [
    { icon: 'mdi-account-cash', label: 'Client', color: 'cyan' },
    { icon: 'mdi-cogs', label: 'License Model', color: 'light-blue' },
    { icon: 'mdi-chart-line', label: 'Usage & Insights', color: 'lime' },
    { icon: 'mdi-check-decagram', label: 'Value Gained', color: 'green lighten-1' }
];
</script>

<style scoped>
.bg-dark {
    background-color: #111;
    min-height: 100vh;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.licensing-dialog {
    width: 100%;
    max-width: 100vw;
    margin: 0 auto;
}

.close-btn {
    position: fixed;
    top: 12px;
    right: 12px;
    z-index: 100;
    background-color: #000000cc;
}

.content-scroll {
    width: 100%;
    max-width: 1100px;
    padding: 16px;
    padding-top: 64px;
    box-sizing: border-box;
}

.finance-card {
    background-color: #1e1e1e;
    padding: 20px;
    border-radius: 16px;
    box-shadow: 0 4px 16px rgba(0, 255, 255, 0.06);
    text-align: center;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.finance-card:hover {
    transform: scale(1.03);
    box-shadow: 0 8px 20px rgba(0, 255, 255, 0.12);
}

.bullet-list {
    text-align: left;
    font-size: 0.9rem;
    margin-top: 8px;
    padding-left: 16px;
    list-style: disc;
}

.flow-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    margin-top: 32px;
    gap: 12px;
    text-align: center;
}

.flow-step {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 500;
    color: white;
}

.flow-label {
    font-size: 0.95rem;
}
</style>